import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import classNames from 'volta/helpers/class-names';
import or from 'ember-truth-helpers/helpers/or';
import orElse from 'volta/helpers/or-else';
import and from 'ember-truth-helpers/helpers/and';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';
import BvBtnGroup from 'volta/components/bv-btn-group';
import BvBtn from 'volta/components/bv-btn';
import type { TOC } from '@ember/component/template-only';
import type { BvBtnArgs } from '../bv-btn';
interface IAction extends BvBtnArgs {
    visible?: boolean;
    classNames?: string;
}
export interface BvCardSectionSignature {
    Args: {
        actions?: IAction[];
        fullWidth?: boolean;
        subdued?: boolean;
        subtitle?: string;
        title?: string;
    };
    Blocks: {
        actions: [];
        default: [];
        title: [];
    };
    Element: HTMLDivElement;
}
const BvCardSectionComponent: TOC<BvCardSectionSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <div
    class={{classNames
      'bv-card__section'
      (if @subdued 'bv-card__section--subdued')
      (if @fullWidth 'bv-card__section--full-width')
    }}
    ...attributes
  >
    {{#if (or @title @actions.length (has-block 'title'))}}
      <div class='bv-card__section-header'>
        <BvInline @blockAlign='baseline' @gap='2'>
          <BvInline @blockAlign='baseline' @gap='2' class='u-flex-1'>
            {{#if @title}}
              <BvText @variant='heading-sm' @text={{@title}} />
            {{else if (has-block 'title')}}
              {{yield to='title'}}
            {{/if}}
            {{#if @subtitle}}
              {{@subtitle}}
            {{/if}}
          </BvInline>

          {{#if @actions.length}}
            <BvBtnGroup @segmented={{false}}>
              {{#each @actions as |act|}}
                {{#if (and act (orElse act.visible true))}}
                  <BvBtn
                    @size={{orElse act.size 'sm'}}
                    @subtle={{act.subtle}}
                    @plain={{orElse act.plain true}}
                    @color={{act.color}}
                    @outline={{act.outline}}
                    @rounded={{act.rounded}}
                    @iconLeft={{act.iconLeft}}
                    @iconRight={{act.iconRight}}
                    @tooltip={{act.tooltip}}
                    @tooltipText={{act.tooltipText}}
                    @tooltipSide={{act.tooltipSide}}
                    @text={{act.text}}
                    @onClick={{act.onClick}}
                    @disabled={{act.disabled}}
                    @isLoading={{act.isLoading}}
                    class={{act.classNames}}
                  />
                {{/if}}
              {{/each}}
            </BvBtnGroup>
          {{/if}}
          {{#if (has-block 'actions')}}
            {{yield to='actions'}}
          {{/if}}
        </BvInline>
      </div>
    {{/if}}
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvCardSectionComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvCard::Section': typeof BvCardSectionComponent;
        'bv-card/section': typeof BvCardSectionComponent;
    }
}
